module.exports = __webpack_public_path__ + "img/pacific-standard.11091497.svg";